import api from './client'

export const authApi = {
  login: (data) => api.post('/login', data),
  register: (data) => api.post('/register', data),
  logout: () => api.post('/logout'),
  me: () => api.get('/me'),
}

export const productApi = {
  list: (params) => api.get('/items', { params }),
  get: (id) => api.get(`/item/${id}/detail`),
  search: (q) => api.get('/items/search', { params: { q } }),
  related: (id) => api.get(`/items/${id}/related`),
  reviews: (id) => api.get(`/items/${id}/reviews`),
  addReview: (id, data) => api.post(`/items/${id}/reviews`, data),
}

export const cartApi = {
  get: () => api.get('/cart'),
  add: (itemId, quantity = 1) => api.post('/cart', { item_id: itemId, quantity }),
  update: (cartItemId, quantity) => api.put(`/cart/${cartItemId}`, { quantity }),
  remove: (cartItemId) => api.delete(`/cart/${cartItemId}`),
  clear: () => api.delete('/cart'),
}

export const wishlistApi = {
  get: () => api.get('/wishlist'),
  toggle: (itemId) => api.post('/wishlist/toggle', { item_id: itemId }),
  remove: (id) => api.delete(`/wishlist/${id}`),
}

export const orderApi = {
  list: () => api.get('/orders'),
  get: (id) => api.get(`/orders/${id}`),
  create: (data) => api.post('/orders', data),
}

export const couponApi = {
  validate: (code, subtotal) => api.post('/coupons/validate', { code, subtotal }),
}

export const recentlyViewedApi = {
  get: () => api.get('/recently-viewed'),
  add: (itemId) => api.post('/recently-viewed', { item_id: itemId }),
}

export const notificationApi = {
  list: () => api.get('/notifications'),
  markRead: (id) => api.patch(`/notifications/${id}/read`),
  markAllRead: () => api.post('/notifications/read-all'),
}

export const adminApi = {
  analytics: () => api.get('/admin/analytics'),
  orders: () => api.get('/admin/orders'),
  updateOrderStatus: (id, status) => api.patch(`/admin/orders/${id}/status`, { status }),
}

export const catalogApi = {
  categories: () => api.get('/catalog/categories'),
  brands: () => api.get('/catalog/brands'),
  banners: (placement) => api.get('/catalog/banners', { params: { placement } }),
  stats: () => api.get('/catalog/stats'),
}

export const typeApi = {
  list: () => api.get('/type'),
}
